import clsx from "clsx";
import React, { FunctionComponent, SVGProps } from "react";

export const PhoneIcon: FunctionComponent<SVGProps<SVGSVGElement>> = ({
  className,
  ...props
}) => {
  return (
    <svg
      {...props}
      className={clsx("tw-icon", className)}
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M23.284 17.85c-.245-.26-1.108-1.03-2.697-2.05-1.6-1.029-2.78-1.67-3.118-1.82a.18.18 0 0 0-.184.024 59.4 59.4 0 0 0-1.512 1.248c-.317.272-.317.272-.578.187-.457-.15-1.878-.904-3.117-2.146-1.238-1.24-2.032-2.697-2.182-3.154-.086-.261-.086-.261.188-.579.042-.049.823-.967 1.248-1.512a.179.179 0 0 0 .023-.183c-.15-.34-.79-1.519-1.819-3.118-1.02-1.588-1.79-2.452-2.051-2.697a.183.183 0 0 0-.182-.04 15.11 15.11 0 0 0-2.625 1.193 15.843 15.843 0 0 0-2.28 1.61.18.18 0 0 0-.06.175c.098.457.566 2.363 2.02 5.003 1.482 2.694 2.51 4.074 4.687 6.244 2.177 2.17 3.601 3.26 6.299 4.742 2.64 1.453 4.546 1.922 5.002 2.019a.181.181 0 0 0 .176-.06 15.838 15.838 0 0 0 1.61-2.28c.48-.835.88-1.714 1.192-2.625a.182.182 0 0 0-.04-.18Z"
        fillRule="evenodd"
      />
    </svg>
  );
};
